$('#modal-help').on('hidden.bs.modal', () => {
  $('#input-cli').focus();
});



/** WEBPACK FOOTER **
 ** ./src/lib/bootstrap-extensions.js
 **/